export const individualPaths = {
    edit: '/details/edit',
    details: '/details',
};
